import React, { useState } from 'react';
import { DashboardMenuLogo } from './DashboardMenuLogo';
import { DashboardMenuItem } from './DashboardMenuItem';
import { DashboardMenuRoleSwitcher } from './DashboardMenuRoleSwitcher';
import { DashboardMenuUserDropdown } from './DashboardMenuUserDropdown';
import CreateMenu from './CreateMenu';
import { useVisibleMenuItems } from './useVisibleMenuItems';
import { PermissionGuard } from 'features/auth/guards/PermissionGuard';
import { AbpPolicies } from 'core/constants/AbpPolicies';

interface DashboardMenuProps {
  isCollapsed: boolean
  onToggle: () => void
}

export const DashboardMenu: React.FC<DashboardMenuProps> = ({ isCollapsed, onToggle }) => {
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  // Filtrage partagé desktop/mobile : permission ABP + rôle actif (menuPolicy)
  // + espace courtier vs compagnie décidé par la casquette (useVisibleMenuItems).
  const { visibleItems } = useVisibleMenuItems();

  return (
    <div className={`
      hidden z-30 md:flex md:flex-col md:fixed md:inset-y-0
      flex-1 flex-col min-h-0
      relative bg-primary
      ${isCollapsed ? 'w-24' : 'w-56'}
    `}>
      <DashboardMenuLogo
        isCollapsed={isCollapsed}
        onToggle={onToggle}
      />
      <div className='h-24'></div>

      <nav className="flex-1 mt-4 px-4 space-y-2 overflow-y-auto">
        {visibleItems.map((item) => (
          <DashboardMenuItem
            key={item.id}
            item={item}
            isCollapsed={isCollapsed}
            isHovered={hoveredItem === item.id}
            onHover={setHoveredItem}
          />
        ))}
      </nav>

      {/* Élément de layout : on MASQUE sans permission (fallbackComponent), jamais de
          Navigate ici — un fallback de navigation depuis le menu persistant boucle
          (ex. casquette Plateforme sans Simulations.Manage sur /bord). */}
      <PermissionGuard policy={AbpPolicies.SIMU_MANAGE} fallbackComponent={<></>}>
        <CreateMenu />
      </PermissionGuard>

      <div className="px-4">
        <DashboardMenuRoleSwitcher isCollapsed={isCollapsed} />
      </div>

      <DashboardMenuUserDropdown isCollapsed={isCollapsed} />
    </div>
  );
};
